import React, { FC } from 'react';
import { FormatGroupLabel } from '../../_FormatGroupLabel';
import { SelectOption } from '../../_Option';
import { IInternalSelectProps, IOptionBase, ISelectInnerProps, ISelectMenuPortal, OnChange } from '../../models';
import { GroupBase, Props } from 'react-select';

interface IProps extends ISelectMenuPortal {}

export interface IGroupedOptionsProps {
  options: IOptionBase | GroupBase<IOptionBase>;
  selectProps: Props<IOptionBase, boolean, GroupBase<IOptionBase>> &
    ISelectInnerProps<IOptionBase, GroupBase<IOptionBase>, boolean> &
    IInternalSelectProps;
  props: IProps;
  handleChange: OnChange;
}

export const GroupedOptions: FC<IGroupedOptionsProps> = ({ options, selectProps, props, handleChange }) => {
  const { storage, getOptionLabel, getOptionValue } = selectProps;
  return (
    <>
      <FormatGroupLabel label={options.label as string} />
      {options.options &&
        options.options.map((el) => (
          <SelectOption
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            selectId={props.selectProps['data-id']!}
            key={el.value}
            data={el}
            onChange={handleChange}
            storage={storage}
            classNamePrefix={selectProps.classNamePrefix}
            values={props.getValue() as IOptionBase[]}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            isSearchView={true}
          />
        ))}
    </>
  );
};
